function game(birdsData, audioDescr, audio, birdsDataEn, namesArray, namesArrayEn) {

  const startBtn = document.getElementById("open-modal");
  const ul = document.getElementsByClassName("item-list list-group")[0];
  const card = document.querySelector('.card-body');
  const descr = document.querySelector('.bird-description');
  const instruction = document.querySelector('.instruction');
  const birdImageDescr = document.querySelector('.bird-image-descr');
  const nameBird = document.querySelector('.name-bird');
  const species = document.querySelector('.species');
  const nameBirdMain = document.getElementById("name-bird-main");
  const birdImage = document.querySelector('.bird-image');
  const NextLevelBtn = document.querySelector('.btn');
  const scoreSpan = document.getElementById("score");
  const pagination = document.querySelectorAll('.page-item');
  const btnGameOver = document.querySelector('.btn-game-over');
  const modalGame = document.getElementById('modal-game');
  const modalScore = document.getElementById('modal-score');
  const finishScore = document.getElementById('finish-score');
 
  let counter = 0;
  let counterNext = 0;
  let score = 5;
  let overalScore = 0;
  let bool = false;
  let boolSound = true;
  let arr = [];

  
  const shuffle = (array) => {
    let currentIndex = array.length,  randomIndex;
  
    // While there remain elements to shuffle.
    while (currentIndex != 0) {
  
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
  
      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }
  
    return array;
  };

  const loadListBirds = () => {
    const birdsNames = document.querySelectorAll(".default");
    
    const svgPlay = document.getElementById('svg-play');
    const svgPause = document.getElementById('svg-pause');

    modalGame.style.display = 'block';
    modalScore.style.display = 'none';
  
    card.style.display = 'none';
    descr.style.display = 'none';
    instruction.style.display = 'block';

    svgPlay.classList.remove('display-none');
    svgPause.classList.add('display-none');

    scoreSpan.innerText = '0';
    nameBirdMain.innerText = '******';
    birdImage.src = "./images/bird_layout.jpg"

    NextLevelBtn.style.background = 'grey';
    NextLevelBtn.style.cursor = 'auto';
    NextLevelBtn.disabled = true;

    pagination.forEach(item => {
      item.classList.remove('active');
    });

    pagination[0].classList.add('active');

    
    score = 5;
    overalScore = 0;
    bool = false;
    boolSound = true;
    counterNext = 0;

    
    //Set rnd audio for question
    let arrAudio = birdsData[counter].map((el) => el.audio);
    const randomAudio = arrAudio[Math.floor(Math.random()*arrAudio.length)];

    audio.src = randomAudio;

    //Load shuffled birds to DOM
    namesArray = shuffle(birdsData[counter].map(function (el) { return el }));

    namesArrayEn = namesArray.map((el) => { 
      let temp = birdsDataEn[counter].find(element => element.image === el.image);
      if (temp.name) {
        //el.name = temp.name;
        return temp.name;
      }
    });

    namesArray = namesArray.map(el => el.name);
    
    birdsNames.forEach((name) => {
      name.remove();
    });

    if (localStorage.getItem("Language") === 'english') {

      namesArrayEn.forEach((name) => {
        const li = document.createElement("li");
            li.classList.add("list-group-item");
            li.classList.add("default");
            li.id = "list-group-item";
        const span = document.createElement("span");
              span.classList.add("li-btn");
        const div = document.createElement("div");
        
        ul.append(li);
        li.append(span);
        li.append(div);
        div.append(`${name}`);
      });

    } else {

      namesArray.forEach((name) => {
        const li = document.createElement("li");
            li.classList.add("list-group-item");
            li.classList.add("default");
            li.id = "list-group-item";
        const span = document.createElement("span");
              span.classList.add("li-btn");
              const div = document.createElement("div");
        
        ul.append(li);
        li.append(span);
        li.append(div);
        div.append(`${name}`);
      });
    }
  }

  startBtn.addEventListener('click', loadListBirds);

  const loadLangBirds = () => {
    const birdsNames = document.querySelectorAll(".default");

   if (localStorage.getItem("Language") === 'english') {
 
    for (let i = 0; i < namesArrayEn.length; i++) {
      birdsNames[i].lastElementChild.innerText = '';
      birdsNames[i].lastElementChild.innerText = `${namesArrayEn[i]}`;
    }

   } else {

    for (let i = 0; i < namesArray.length; i++) {
      birdsNames[i].lastElementChild.innerText = '';
      birdsNames[i].lastElementChild.innerText = `${namesArray[i]}`;
    }
   }
 }

 const toggle=document.getElementById("toggle");

 toggle.addEventListener('click', loadLangBirds);

  //Choose Bird - load card

  const loadClickedCard = (e) => {
    
    const svgPlayDescr = document.getElementById('svg-play-descr');
    const svgPauseDescr = document.getElementById('svg-pause-descr');
    const errorSound = document.getElementById('errorSound');
    const winSound = document.getElementById('winSound');
    const svgPlay = document.getElementById('svg-play');
    const svgPause = document.getElementById('svg-pause');

    svgPlayDescr.classList.remove('display-none');
    svgPauseDescr.classList.add('display-none');
    
    if (e.target && e.target.matches("li.list-group-item")) {

      if (localStorage.getItem("Language") === 'english') {
        birdsDataEn[counterNext].forEach(el => {
          if (el.name === e.target.innerText) {
            //console.log(el);
            arr = el;
          }
        });

      } else {

        birdsData[counterNext].forEach(el => {
          if (el.name === e.target.innerText) {
            //console.log(el);
            arr = el;
          }
        });
      }
    }

    card.style.display = 'flex';
    descr.style.display = 'flex';
    instruction.style.display = 'none';

    audioDescr.src = arr.audio;
    
    birdImageDescr.src = arr.image;
    nameBird.innerText = arr.name;
    species.innerText = arr.species;
    descr.innerText = arr.description;

    if (arr.audio === audio.src && boolSound == true) {
      
      errorSound.pause();
      errorSound.currentTime = 0;
      winSound.pause();
      winSound.currentTime = 0;
      winSound.play();

      svgPlay.classList.remove('display-none');
      svgPause.classList.add('display-none');
      audio.pause();
      audio.currentTime = 0;

      svgPlayDescr.classList.remove('display-none');
      svgPauseDescr.classList.add('display-none');
      audioDescr.pause();
      audioDescr.currentTime = 0;
      
      e.target.firstElementChild.style.background = 'green';
      NextLevelBtn.style.background = '#EE3E38';
      NextLevelBtn.style.cursor = 'pointer';
      NextLevelBtn.disabled = false;


      nameBirdMain.innerText = arr.name;
      birdImage.src = arr.image;

      scoreSpan.innerText = overalScore + score;

      bool = true;
      boolSound = false;

    } else if (bool == false) {
      
      winSound.pause();
      winSound.currentTime = 0;
      errorSound.pause();
      errorSound.currentTime = 0;
      errorSound.play();

      e.target.firstElementChild.style.background = 'red';
      score--;
    }
  };

  ul.addEventListener('click', loadClickedCard);
 

  const nextLevel = () => {
    const birdsNames = document.querySelectorAll(".default");
    const svgPlay = document.getElementById('svg-play');
    const svgPause = document.getElementById('svg-pause');
    
    overalScore += score;

    if (counterNext === 5 && overalScore < 30) {
      console.log('You win!');
      
      modalGame.style.display = 'none';
      modalScore.style.display = 'block';
      finishScore.innerText = `${overalScore}`;

    } else if (counterNext === 5 && overalScore === 30) {

      const winMsg = document.querySelector('.lead');

      winMsg.innerText = "Викторина пройдена";

    } else {

      bool = false;
      boolSound = true;
      score = 5;
   
      counterNext++;
      console.log('Overal score: ' + overalScore);

      const activeDir = document.querySelector('.active');
      activeDir.nextElementSibling.classList.add('active');
      activeDir.classList.remove('active');

      scoreSpan.innerText = overalScore;
      pagination[counterNext].classList.add('active');
      pagination[0].classList.remove('active');

      card.style.display = 'none';
      descr.style.display = 'none';
      instruction.style.display = 'block';

      svgPlay.classList.remove('display-none');
      svgPause.classList.add('display-none');

      nameBirdMain.innerText = '******';
      birdImage.src = "./images/bird_layout.jpg"

      NextLevelBtn.style.background = 'grey';
      NextLevelBtn.style.cursor = 'auto';
      NextLevelBtn.disabled = true;

      //Set rnd audio for question
      let arrAudio = birdsData[counterNext].map((el) => el.audio);
      const randomAudio = arrAudio[Math.floor(Math.random()*arrAudio.length)];

      audio.src = randomAudio;

      //Load shuffled birds to DOM
      namesArray = shuffle(birdsData[counterNext].map(function (el) { return el }));

      namesArrayEn = namesArray.map((el) => { 
        let temp = birdsDataEn[counterNext].find(element => element.image === el.image);
        if (temp.name) {
          //el.name = temp.name;
          return temp.name;
        }
      });

      namesArray = namesArray.map(el => el.name);

      birdsNames.forEach((name) => {
        name.remove();
      });

      if (localStorage.getItem("Language") === 'english') {

        namesArrayEn.forEach((name) => {
          const li = document.createElement("li");
              li.classList.add("list-group-item");
              li.classList.add("default");
              li.id = "list-group-item";
          const span = document.createElement("span");
                span.classList.add("li-btn");
          const div = document.createElement("div");
  
          ul.append(li);
          li.append(span);
          li.append(div);
          div.append(`${name}`);
        });
  
      } else {
  
        namesArray.forEach((name) => {
          const li = document.createElement("li");
              li.classList.add("list-group-item");
              li.classList.add("default");
              li.id = "list-group-item";
          const span = document.createElement("span");
                span.classList.add("li-btn");
          const div = document.createElement("div");
  
          ul.append(li);
          li.append(span);
          li.append(div);
          div.append(`${name}`);
        });
      }
    }
  }

  NextLevelBtn.addEventListener('click', nextLevel);
  btnGameOver.addEventListener('click', loadListBirds)
}

export default game;